<template>
  <div class="home">
    <hero-section></hero-section>
    <medium-home-section></medium-home-section>
    <small-home-section :features="features"></small-home-section>
    <medium-home-section-two :skills="skills"></medium-home-section-two>
    <medium-home-section-three></medium-home-section-three>
    <small-home-section-two></small-home-section-two>
  </div>
</template>

<script>
export default {
    computed: {
        skills() {
            return this.$store.state.loadedSkills
        },
        features() {
            return this.$store.state.loadedFeatures
        }
    }
}
</script>

